import { Box, MediaBox, Typography, Video } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import Image from "components/landing/image"
import StyledLink from "components/landing/link"

const Features = ({ data, descriptionOnTop }) => (
  <>
    {data.map((feature, i) => (
      <Box key={`${feature.content.title}${i}`} {...feature.wrapperStyle}>
        <Box
          alignItems="center"
          contain
          display={{
            _: feature.image.unEvenBlock ? "flex" : "block",
            tablet: "flex",
          }}
          flexWrap={{ _: "wrap-reverse", tablet: "nowrap" }}
          mb={{ _: 4, tablet: 6 }}
          textAlign="center"
          {...feature.BoxStyle}
        >
          <Box
            flex={feature.image.unEvenBlock ? "30%" : 1}
            order={feature.content.position === "right" ? 2 : 1}
            {...feature.content.ContentStyle}
          >
            <Typography
              fontSize={25}
              lineHeight={1}
              mb={2}
              {...feature.content.titleStyle}
            >
              {feature.content.title}
            </Typography>
            <Typography mb={2} {...feature.content.descriptionMobileStyle}>
              {feature.content.descriptionMobile}
            </Typography>
            <MediaBox
              mb={{ _: 5, tablet: 0 }}
              {...(descriptionOnTop && { greaterThanOrEqual: "tablet" })}
            >
              <Typography mb={2} {...feature.content.descriptionStyle}>
                {feature.content.description}
              </Typography>
              {feature.links && (
                <StyledLink
                  style={feature.links.style}
                  type={feature.links.base_style}
                  url={feature.links.url}
                  {...feature.links}
                >
                  {feature.links.text}
                </StyledLink>
              )}
            </MediaBox>
          </Box>
          <Box
            flex={feature.image.unEvenBlock ? "70%" : 1}
            order={feature.content.position === "right" ? 1 : 2}
          >
            {feature.video ? (
              <Video
                lazyload
                margin="auto"
                poster={`${sl.config.jewlr_asset_url}homepage_videos/2021/${feature.video.poster}`}
                video={`${sl.config.jewlr_asset_url}homepage_videos/2021/${feature.video.url}`}
                width={{ tablet: "70%" }}
              />
            ) : (
              <Image image={feature.image} />
            )}

            {descriptionOnTop && (
              <MediaBox lessThan="tablet" mb={6}>
                <Typography
                  fontSize={25}
                  lineHeight={1}
                  mb={2}
                  {...feature.content.titleStyle}
                >
                  {feature.content.secondTitle}
                </Typography>
                <Typography mb={2} {...feature.content.descriptionStyle}>
                  {feature.content.description}
                </Typography>
                {feature.links && (
                  <StyledLink
                    style={feature.links.style}
                    type={feature.links.base_style}
                    url={feature.links.url}
                    {...feature.links}
                  >
                    {feature.links.text}
                  </StyledLink>
                )}
              </MediaBox>
            )}
          </Box>
        </Box>
      </Box>
    ))}
  </>
)

Features.propTypes = {
  data: PropTypes.array,
  descriptionOnTop: PropTypes.bool,
}
export default Features
